import React from 'react';
import { MapPin, ShoppingBag, TrendingUp, ChevronRight } from 'lucide-react';

const steps = [
  {
    n: '1',
    icon: MapPin,
    title: 'Search Your ZIP Code',
    body: 'Enter your ZIP code to discover local restaurants near you.',
  },
  {
    n: '2',
    icon: ShoppingBag,
    title: 'Order Directly',
    body: 'Place your order directly with the restaurant. No middleman.',
  },
  {
    n: '3',
    icon: TrendingUp,
    title: 'Restaurants Keep More Profit',
    body: 'Restaurants keep 100% of their earnings. You pay less. Everyone wins.',
  },
];

const HowItWorksV2Section = () => {
  return (
    <section
      id="how-it-works"
      className="relative bg-black py-14 lg:py-20"
      data-testid="how-it-works-v2"
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-white tracking-tight mb-7">
          How It Works
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr_auto_1fr] gap-4 md:gap-6 items-stretch">
          {steps.map((s, i) => (
            <React.Fragment key={s.n}>
              <div
                data-testid={`how-it-works-step-${s.n}`}
                className="rounded-2xl bg-gradient-to-br from-zinc-950 to-black border border-zinc-800 hover:border-gold-500/30 p-6 lg:p-7 transition-colors"
              >
                <div className="flex items-start gap-4">
                  <div className="relative flex-shrink-0">
                    <div className="w-14 h-14 rounded-2xl bg-gold-500/[0.06] border border-gold-500/30 flex items-center justify-center">
                      <s.icon className="w-6 h-6 text-gold-400" strokeWidth={1.5} />
                    </div>
                    <span className="absolute -top-1.5 -right-1.5 w-6 h-6 rounded-full bg-gold-500 text-black text-[11px] font-black flex items-center justify-center shadow-md">
                      {s.n}
                    </span>
                  </div>
                  <div>
                    <div className="text-[15px] font-extrabold text-white tracking-tight">{s.title}</div>
                    <p className="mt-2 text-[13px] text-white/60 leading-relaxed">{s.body}</p>
                  </div>
                </div>
              </div>

              {i < steps.length - 1 && (
                <div className="hidden md:flex items-center justify-center text-gold-400/60">
                  <ChevronRight className="w-6 h-6" />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksV2Section;
